import React from 'react';

import styles from './About.module.scss';


class About extends React.Component {
  render() {
    return (
      <div className={styles.About}>
        <p>
          Jesteśmy specjalistami w projektowaniu, produkcji i sprzedaży najwyższej jakości
          schodów drewnianych. Schody wykonujemy z każdego rodzaju drewna,
          zależnie od potrzeb Klienta. Indywidualnie podchodzimy do każdego zlecienia dzięki czemu
          każde schody są wyjątkowe i jedyne w swoim rodzaju.
        </p>
        <p>Zapewniamy to co jest dla Ciebie najważniejsze:</p>
        <ul>
          <li>Trwałość</li>
          <li>Piękny wygląd</li>
          <li>Terminowość</li>
          <li>Niska cena</li>
        </ul>
        <p>Skontaktuj się już teraz, aby zamówić swoje wymarzone schody.</p>
      </div>
    )
  }
}

export default About;
